import { getRange } from "@pentacode/core";
import type { DateString } from "@pentacode/openapi";
import { createRoute } from "../../lib/tsr/router";
import type { AppRootRoute } from "../app-router-context";
import { prefetchRoster } from "./roster.queries";

/**
 * Data only: the legacy `ptc-roster` still renders and reads the query cache
 * this loader warms, so hovering the main menu entry preloads the roster.
 */
export function createRosterRoute(parent: AppRootRoute) {
    return createRoute({
        getParentRoute: () => parent,
        path: "roster",
        loader: ({ location, context }) => {
            const { from, to, tab } = location.search as Record<string, string | undefined>;
            const range = from && to ? { from: from as DateString, to: to as DateString } : getRange(new Date(), "week");
            return prefetchRoster(context.app, context.queryClient, { tab: Number(tab ?? 0), range });
        },
    });
}
